import { useParams, useRouteMatch } from "react-router-dom"
import _ from "lodash"

import { useScenarioEditor } from "./ScenarioEditorContext"

import ProblemsLayout from "./ProblemsLayout"
import { InlineModelAdmin, AddModel } from "../admins"
import {
    Checkbox,
    // Text,
    TextInput
} from "../widgets"

import { genProblemRec } from "../ScenarioTypeEditor/InterventionsEditor/types"
import { getProblemsBC } from "../ScenarioTypeEditor/urls"
import { groupByKey, swapUp, swapDown } from "../ScenarioTypeEditor/utils"


const problemRE = /^problem-(\d+)$/

const ProblemsList = () => {
    const params = useParams()
    const {url} = useRouteMatch()
    const {scenario, problems, solutions, actions, uniqueIDs, uniqueLabels, updateScenarioFld} = useScenarioEditor()

    const probIDGenerator = () => {
        let nextNum = 1
        let max = _.max(scenario.problems.map(e => parseInt(e.id.match(problemRE)[1], 10)))
        if (!!max) {
            nextNum = max + 1
        }
        const newID = `problem-${nextNum}`
        console.log(newID)
        return newID
    }

    const moveProbUp = (probIdx) => {
        updateScenarioFld("problems", swapUp(scenario.problems, probIdx))
    }

    const moveProbDown = (probIdx) => {
        updateScenarioFld("problems", swapDown(scenario.problems, probIdx))
    }

    const addProblemHandler = (entityType, id, label) => {
        const rec = genProblemRec(id, label)
        problems.add(rec)
    }

    const updateProblemFld = (probID, fldName, fldVal) => {
        console.log(probID, fldName, fldVal)
        const rec = {...scenario.problems.find(e => e.id === probID), [fldName]: fldVal}
        problems.update(rec)
    }

    const deleteProblemHandler = (item) => {
        const prob = scenario.problems.find(e => e.id === item.id)
        let msg = `Are you sure you wish to delete problem "${prob.label}"`
        const sols = scenario.solutions.filter(e => e.problemID === item.id)
        const acts = scenario.actions.filter(e => e.problemID === item.id)
        const solActions = groupByKey(acts, "solutionID")
        if (sols.length > 0) {
            msg += " and all of it's children?\n"
            msg += "Solutions:\n------------------\n"
            sols.forEach(sol => {
                msg += `\t${sol.label}\n`
                msg += `\tActions:\n`
                solActions[sol.id].forEach(act => {
                    msg += `\t\t${act.interventionID}\n`
                })
            })
        }
        if (window.confirm(msg)) {
            acts.forEach(act => actions.remove(act.id))
            sols.forEach(sol => solutions.remove(sol.id))
            problems.remove(prob.id)
        }
    }

    return (
        <ProblemsLayout breadcrumbs={[getProblemsBC(params)]}>
            <InlineModelAdmin
                heading="Problems"
                records={scenario.problems}
                fields={[
                    // {name: "id", label: "ID", colWidthPct: 6, widget: Text, textSize: "xx-small"},
                    {name: "label", label: "Label", colWidthPct: 94, widget: TextInput, size: 120, changeHandler: updateProblemFld},
                    {name: 'lifeThreat', label: "Is Life Threat", colWidthPct: 6, widget: Checkbox, changeHandler: updateProblemFld}
                ]}
                editLink={true}
                editBaseURL={url}
                allowChangeOrder={true}
                onMoveUp={moveProbUp}
                onMoveDown={moveProbDown}
                onDelete={deleteProblemHandler}
            >
                <AddModel
                    model={{type: "problem", name: "Problem", labelsUnique: false}}
                    addHandler={addProblemHandler}
                    uniqueIDs={uniqueIDs}
                    uniqueLabels={uniqueLabels}
                    idGenerator={probIDGenerator}
                />
            </InlineModelAdmin>
        </ProblemsLayout>
    )
}

export default ProblemsList